import {useState} from "react";
import {Input, Tag} from "antd";
import {PlusOutlined} from "@ant-design/icons";

export function EditableTags({
                                 record,
                                 onSave
                             }: { record: any, onSave: (path: string, tags: string[]) => Promise<any> }) {
    const [tags, setTags] = useState<string[]>(record.tags || []);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const handleClose = (removedTag: string) => {
        const newTags = tags.filter(tag => tag !== removedTag);
        setTags(newTags);
        onSave(record.path, newTags); // ✅ update backend
    };

    const showInput = () => setInputVisible(true);

    const handleInputConfirm = () => {
        if (inputValue && !tags.includes(inputValue)) {
            const newTags = [...tags, inputValue];
            setTags(newTags);
            onSave(record.path, newTags);
        }
        setInputVisible(false);
        setInputValue("");
    };

    return (
        <div onClick={(e) => e.stopPropagation()}>
            {tags.map(tag => (
                <Tag key={tag} closable onClose={() => handleClose(tag)}>
                    {tag}
                </Tag>
            ))}
            {inputVisible ? (
                <Input
                    size="small"
                    style={{width: 80}}
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onBlur={handleInputConfirm}
                    onPressEnter={handleInputConfirm}
                    autoFocus
                />
            ) : (
                <Tag onClick={showInput} style={{background: "#fff", borderStyle: "dashed", cursor: "pointer"}}>
                    <PlusOutlined/> Add Tag
                </Tag>
            )}
        </div>
    );
}
